// src/components/Checkout/OrderSummary.jsx  (only change: accept disablePay and show deliveryFee)
import React from "react";

export default function OrderSummary({
  cartItems,
  totalPrice,
  isLoading,
  checkingStock,
  placingOrder,
  onPlaceOrder,
  deliveryFee = 0,
  disablePay = false,
}) {
  const totalWithDelivery = (Number(totalPrice) + Number(deliveryFee || 0)).toFixed(2);

  return (
    <div className="bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-slate-100 dark:border-slate-800 overflow-hidden">
      <div className="p-6 border-b border-slate-100 dark:border-slate-800">
        <h3 className="text-xl font-bold text-slate-900 dark:text-white">
          Order Summary
        </h3>
      </div>

      <div className="p-6 space-y-4 max-h-[300px] overflow-y-auto">
        {cartItems.map((cartItem) => {
          const { item, quantity, key, selectedRequiredOption, selectedOptionalOptions } = cartItem;

          const options = [];
          if (selectedRequiredOption) options.push(selectedRequiredOption);
          if (selectedOptionalOptions?.length) options.push(...selectedOptionalOptions);

          return (
            <div key={key} className="flex gap-4">
              <div className="flex-grow min-w-0">
                <div className="flex justify-between gap-3">
                  <h4 className="font-semibold text-slate-900 dark:text-white">
                    {item.item_name}
                  </h4>
                  <span className="font-medium text-slate-900 dark:text-white whitespace-nowrap">
                    £{(cartItem.totalPrice || 0).toFixed(2)}
                  </span>
                </div>

                {options.length > 0 && (
                  <p className="text-xs text-slate-500 mt-1 truncate">
                    {options
                      .map(
                        (opt) =>
                          `${opt.option_name}${opt.quantity > 1 ? ` x${opt.quantity}` : ""}`
                      )
                      .join(", ")}
                  </p>
                )}

                <div className="flex items-center gap-2 mt-2">
                  <span className="text-xs font-medium px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded">
                    Qty: {quantity}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="p-6 bg-slate-50/50 dark:bg-slate-800/50 space-y-3">
        <div className="flex justify-between text-slate-600 dark:text-slate-400">
          <span>Subtotal</span>
          <span>£{totalPrice}</span>
        </div>

        {Number(deliveryFee) > 0 && (
          <div className="flex justify-between text-slate-600 dark:text-slate-400">
            <span>Delivery fee</span>
            <span>£{Number(deliveryFee).toFixed(2)}</span>
          </div>
        )}

        <div className="pt-3 mt-3 border-t border-slate-200 dark:border-slate-700 flex justify-between items-center">
          <span className="text-lg font-bold text-slate-900 dark:text-white">
            Total
          </span>
          <span className="text-2xl font-bold text-primary">
            £{totalWithDelivery}
          </span>
        </div>

        <button
          type="button"
          onClick={onPlaceOrder}
          disabled={isLoading || disablePay || cartItems.length === 0}
          className={`w-full text-white font-bold py-4 rounded-xl shadow-lg shadow-primary/20 transition-all active:scale-[0.98] mt-4 flex items-center justify-center gap-2 ${
            isLoading || disablePay
              ? "bg-slate-400 cursor-not-allowed"
              : "bg-primary hover:bg-primary/90"
          }`}
        >
          {placingOrder
            ? "Redirecting to payment..."
            : checkingStock
              ? "Checking Stock..."
              : "Pay Online"}
          <span className="material-icons">arrow_forward</span>
        </button>

        <div className="flex flex-col items-center gap-2 mt-6">
          <div className="flex items-center gap-1 text-[10px] text-slate-400 uppercase tracking-widest font-bold">
            <span className="material-icons text-xs">lock</span>
            Secure Checkout
          </div>
        </div>
      </div>
    </div>
  );
}
